<ng-template #notificationTemplate>
  <mat-card>
    <div class="notification-container-header">
      <div box direction="row" fill="horizontal" justify="between" align="center" class="notifications-title-container">
        <div class="notifications-title">
          <span>{{ 'sharedNav.appNotifications.title' | transloco }}</span>
        </div>
        <div class="notifications-close">
          <button mat-icon-button color="primary" class="xs" (click)="close()">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </div>
      </div>
      <div box direction="row"  justify="between" align="center" class="mat-tabs-border">
        <mat-tab-group #MatTabGroup animationDuration="0" [disableRipple]="true"
          (selectedTabChange)="onTabChange($event)">
          @for (item of inAppNotificationTabs; track item) {
            <mat-tab [label]="item.name">
              <ng-template mat-tab-label>
                @if (item.name === 'All') {
                  <span class="{{matomoClass}}">
                    {{item.name}}
                  </span>
                } @else {
                  <span class="{{matomoClass}}">
                    {{item.name}} ({{ unReadNotificationCount()}})
                  </span>
                }
                <ng-template #unReadtemplate>
                  <span class="{{matomoClass}}">
                    {{item.name}} ({{ unReadNotificationCount()}})
                  </span>
                </ng-template>
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
        @if (inAppNotificationsRecentData()!.length > 0 || inAppNotificationsOlderData()!.length > 0) {
          <div class="menu-button"
            >
            <button mat-icon-button class="xs" color="primary" [matMenuTriggerFor]="menu" [attr.aria-label]="'sharedNav.appNotifications.actionsAria' | transloco">
              <mat-icon svgIcon="more-vertical"></mat-icon>
            </button>
          </div>
        }
        <mat-menu #menu="matMenu">
          <button mat-menu-item [disabled]="(appNotificationService.isEnableNotificationBellIcon | async) === false"
            (click)="onMarkAsAllNotifications()">
            <span>{{ 'sharedNav.appNotifications.markAllAsRead' | transloco }}</span>
          </button>
          <button mat-menu-item (click)="onDeleteAllNotifications()">
            <span>{{ 'sharedNav.appNotifications.deleteAll' | transloco }}</span>
          </button>
        </mat-menu>
      </div>

      <div box direction="row">
        @if (displaySearchBar()) {
          <div class="notification_search">
            <mat-form-field appearance="outline" class="w-100">
              <input matInput spellcheck="false" autocomplete="off" placeholder="{{notificationPlaceHolder()}}"
                [ngModel]="notificationSearchValue()" (ngModelChange)="onSearchNotifications($event)">
              <mat-icon matSuffix svgIcon="search" class="search-icon" aria-disabled="true"></mat-icon>
            </mat-form-field>
          </div>
        }
      </div>
    </div>

  </mat-card>
  <mat-card class="component-container" id="slide-card">
    <mat-card-content>
      @if (inAppNotificationsRecentData()!.length > 0 || inAppNotificationsOlderData()!.length > 0) {
        <div box direction="row" class="notification-content-section"
          >
          <!-- Last 7 Days Notifications -->
          @if (inAppNotificationsRecentData()!.length > 0) {
            <div class="notification-content-card">
              <app-notifications-content [inAppNotificationsData]="inAppNotificationsRecentData()"
                (onMarkAsReadNotification)="onMarkAsReadNotification($event)"
                [notificationAggregator]="notificationAggregator()"
                (onMarkAsUnReadNotification)="onMarkAsUnReadNotification($event)">
              </app-notifications-content>
            </div>
          }
          @if (inAppNotificationsOlderData()!.length > 0) {
            <div class="notification-content-card">
              <app-notifications-content [inAppNotificationsData]="inAppNotificationsOlderData()"
                (onMarkAsReadNotification)="onMarkAsReadNotification($event)"
                [notificationAggregator]="'sharedNav.appNotifications.olderNotifications' | transloco"
                (onMarkAsUnReadNotification)="onMarkAsUnReadNotification($event)">
              </app-notifications-content>
            </div>
          }
        </div>
      } @else {
        <div class="notification_none">
          <div>
            <mat-icon svgIcon="no-notifications"> </mat-icon>
          </div>
          <h2 class="notification_none_sub_text">{{ 'sharedNav.appNotifications.noNotifications' | transloco }}</h2>
          <p class="notification_none_sub_text">{{ 'sharedNav.appNotifications.noNotificationsSubtext' | transloco }}</p>
        </div>
      }

      <ng-template #nonotifications>
        <div class="notification_none">
          <div>
            <mat-icon svgIcon="no-notifications"> </mat-icon>
          </div>
          <h2 class="notification_none_sub_text">{{ 'sharedNav.appNotifications.noNotifications' | transloco }}</h2>
          <p class="notification_none_sub_text">{{ 'sharedNav.appNotifications.noNotificationsSubtext' | transloco }}</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</ng-template>
